// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__uqBBM","row":"Option_row__34Lkr"};